export default __webpack_public_path__ + "static/media/nasiralmolk.666e7d8b.jpg";